// Studyo Today Backend
// Package studyo.today.schedules.v1.resources
// Resource definitions
// Copyright (c) 2015-2023 Intuitic Inc.

// @generated by protoc-gen-es v2.2.5 with parameter "import_extension=js"
// @generated from file studyo/today/schedules/v1/resources/partial_activity_schedule.proto (package studyo.today.schedules.v1.resources, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";
import { file_studyo_today_schedules_v1_resources_activity } from "./activity_pb.js";

/**
 * Describes the file studyo/today/schedules/v1/resources/partial_activity_schedule.proto.
 */
export const file_studyo_today_schedules_v1_resources_partial_activity_schedule = /*@__PURE__*/
  fileDesc("CkNzdHVkeW8vdG9kYXkvc2NoZWR1bGVzL3YxL3Jlc291cmNlcy9wYXJ0aWFsX2FjdGl2aXR5X3NjaGVkdWxlLnByb3RvEiNzdHVkeW8udG9kYXkuc2NoZWR1bGVzLnYxLnJlc291cmNlcyKgAQoXUGFydGlhbEFjdGl2aXR5U2NoZWR1bGUSCgoCaWQYASABKAkSPwoIYWN0aXZpdHkYAiABKAsyLS5zdHVkeW8udG9kYXkuc2NoZWR1bGVzLnYxLnJlc291cmNlcy5BY3Rpdml0eRIPCgd0ZXJtX2lkGAMgASgJEhQKDHNjaGVkdWxlX3RhZxgEIAEoCRIRCglyb29tX25hbWUYBSABKAlCK6oCKFN0dWR5by5Ub2RheS5TY2hlZHVsZXMuR3JwYy5WMS5SZXNvdXJjZXNiBnByb3RvMw", [file_studyo_today_schedules_v1_resources_activity]);

/**
 * Describes the message studyo.today.schedules.v1.resources.PartialActivitySchedule.
 * Use `create(PartialActivityScheduleSchema)` to create a new message.
 */
export const PartialActivityScheduleSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_schedules_v1_resources_partial_activity_schedule, 0);

